import { FilterItem } from "@/components/filter/filter.types.ts";
import { useOrganizationViewFilter } from "@/queries/settings/use-organization.query.ts";
import { buildViewFilterSearchParams } from "@/types/organization.types.ts";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export function useReportViewFilter(filters: FilterItem[]): boolean {
  const [searchParams, setSearchParams] = useSearchParams();
  const { data: viewFilter, isLoading: isLoadingViewFilter } = useOrganizationViewFilter();
  const [viewFilterApplied, setViewFilterApplied] = useState(() => searchParams.toString() !== "");

  const viewFilterQuery =
    !viewFilterApplied && !isLoadingViewFilter && viewFilter && searchParams.toString() === ""
      ? buildViewFilterSearchParams(viewFilter, filters, searchParams).toString()
      : "";

  if (!viewFilterApplied && !isLoadingViewFilter && !viewFilterQuery) {
    setViewFilterApplied(true);
  }

  useEffect(() => {
    if (viewFilterQuery) setSearchParams(viewFilterQuery);
  }, [viewFilterQuery, setSearchParams]);

  return viewFilterApplied;
}
